/* Viva Sole — progressive enhancements (Plan §13)
   Hero parallax + scroll-down arrow · PDP "Made in Italy" badge + shine ·
   Size Guide modal · mobile sticky add-to-bag.
   Vanilla, idempotent, reduced-motion aware. Targets real Horizon hooks only. */
(function () {
  'use strict';
  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- Hero: parallax video + scroll-down arrow ---------- */
  function heroEnhance(scope) {
    (scope || document).querySelectorAll('.hero').forEach(function (hero) {
      if (hero.dataset.vsHero) return;
      hero.dataset.vsHero = '1';
      var container = hero.querySelector('.hero__container');
      var wrapper = hero.closest('.section-wrapper');

      // animated scroll-down arrow (only if there is a following section)
      if (container && wrapper && wrapper.nextElementSibling &&
          !container.querySelector('.vs-hero-scroll-arrow')) {
        var arrow = document.createElement('button');
        arrow.type = 'button';
        arrow.className = 'vs-hero-scroll-arrow';
        arrow.setAttribute('aria-label', 'Scroll to content');
        arrow.innerHTML = '<span aria-hidden="true">↓</span>';
        arrow.addEventListener('click', function () {
          wrapper.nextElementSibling.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'start' });
        });
        container.appendChild(arrow);
      }

      // a11y (WCAG 2.2.2): pause/play control for the autoplaying hero video(s)
      var heroVids = hero.querySelectorAll('video');
      if (heroVids.length && container && !container.querySelector('.vs-hero-pause')) {
        var pbtn = document.createElement('button');
        pbtn.type = 'button';
        pbtn.className = 'vs-hero-pause';
        var heroPaused = REDUCE; // start paused when the user prefers reduced motion
        if (REDUCE) { heroVids.forEach(function (v) { try { v.pause(); } catch (e) {} }); }
        var syncPause = function () {
          pbtn.setAttribute('aria-label', heroPaused ? 'Play background video' : 'Pause background video');
          pbtn.innerHTML = '<span aria-hidden="true">' + (heroPaused ? '▶' : '❚❚') + '</span>';
        };
        syncPause();
        pbtn.addEventListener('click', function () {
          heroPaused = !heroPaused;
          heroVids.forEach(function (v) { try { heroPaused ? v.pause() : v.play().catch(function () {}); } catch (e) {} });
          syncPause();
        });
        container.appendChild(pbtn);
      }

      // parallax (skip on reduced-motion or the auto-height hero variant)
      if (REDUCE || hero.classList.contains('hero--no-blocks-auto-height')) return;
      var videos = hero.querySelectorAll('.hero__video');
      if (!videos.length) return;
      videos.forEach(function (v) { v.style.willChange = 'transform'; });
      var ticking = false, onScreen = false;
      function apply() {
        ticking = false;
        if (!onScreen) return;
        var rect = hero.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        var p = (rect.top + rect.height / 2 - vh / 2) / vh;
        p = Math.max(-0.5, Math.min(0.5, p));
        var ty = (p * -44).toFixed(1);
        for (var i = 0; i < videos.length; i++) {
          videos[i].style.transform = 'translate3d(0,' + ty + 'px,0) scale(1.12)';
        }
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }
      var io = new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        if (onScreen) apply();
      }, { threshold: 0 });
      io.observe(hero);
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      apply();
    });
  }

  /* ---------- PDP gallery: "Made in Italy" badge ---------- */
  function madeInItalyBadge(scope) {
    (scope || document).querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.closest('.dialog-zoomed-gallery')) return; // never the zoom dialog
      if (gallery.dataset.vsBadge) return;
      gallery.dataset.vsBadge = '1';
      var first = gallery.querySelector('.product-media-container');
      if (!first || first.querySelector('.vs-badge')) return;
      var badge = document.createElement('span');
      badge.className = 'vs-badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = 'Made in Italy';
      first.appendChild(badge);
    });
  }

  /* ---------- PDP: Size Guide trigger + modal ---------- */
  var sizeDialog = null;
  function buildSizeDialog() {
    if (sizeDialog) return sizeDialog;
    var d = document.createElement('dialog');
    d.className = 'dialog-modal vs-size-guide';
    d.innerHTML =
      '<div class="vs-size-guide__inner">' +
        '<button type="button" class="vs-size-guide__close" aria-label="Close size guide">✕</button>' +
        '<div class="vs-size-guide__eyebrow">Viva Sole</div>' +
        '<h3 class="vs-size-guide__title">Size Guide</h3>' +
        '<p class="vs-size-guide__intro">Find your perfect fit. Each pair of VIVA SOLE shoes is crafted in Italy on European lasts, balancing sculptural elegance and all-day comfort. If you\'re between two sizes, we recommend the larger size for a more comfortable fit.</p>' +
        '<div class="vs-size-guide__subhead">Women\'s Size Conversion Chart</div>' +
        '<div class="vs-size-guide__table-wrap">' +
          '<table class="vs-size-guide__table"><thead><tr><th class="is-us">US</th><th>EU</th><th>IT</th><th>Foot (cm)</th></tr></thead><tbody>' +
            '<tr><td class="is-us">5.5</td><td>36</td><td>36</td><td>22.5</td></tr>' +
            '<tr><td class="is-us">6.5</td><td>36.5</td><td>37</td><td>23.3</td></tr>' +
            '<tr><td class="is-us">7.5</td><td>37.5</td><td>38</td><td>24.1</td></tr>' +
            '<tr><td class="is-us">8.5</td><td>38.5</td><td>39</td><td>24.9</td></tr>' +
            '<tr><td class="is-us">9</td><td>39.5</td><td>40</td><td>25.5</td></tr>' +
          '</tbody></table>' +
        '</div>' +
        '<ul class="vs-size-guide__notes">' +
          '<li>VIVA SOLE heels are handcrafted in Italy; small variations in fit may occur due to artisanal production.</li>' +
          '<li>If you have a wide foot, we suggest sizing up half a size for optimal comfort.</li>' +
          '<li>For pointed-toe silhouettes, we also recommend taking half a size up.</li>' +
          '<li>For open-toe or sandal styles, your true size will typically provide the best fit.</li>' +
        '</ul>' +
        '<p class="vs-size-guide__contact">Unsure of your size? Reach out to our Client Services team at <a href="mailto:hello@vivasole.us">hello@vivasole.us</a> and we\'ll guide you to your perfect fit.</p>' +
      '</div>';
    document.body.appendChild(d);
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.querySelector('.vs-size-guide__close').addEventListener('click', function () { d.close(); });
    sizeDialog = d;
    return d;
  }
  var SG_ICON = '<svg class="vs-size-guide-trigger__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><rect x="2" y="8" width="20" height="8" rx="1"></rect><path d="M7 8v3M12 8v4M17 8v3" stroke-linecap="round"></path></svg>';
  function injectSizeGuide(vp) {
    var target = null;
    vp.querySelectorAll('.variant-option').forEach(function (opt) {
      var leg = opt.querySelector('legend, label');
      if (!leg) return;
      var label = ((leg.firstChild && leg.firstChild.textContent) || leg.textContent || '').trim().toLowerCase();
      if (label.indexOf('size') !== -1 || label.indexOf('talla') !== -1) target = opt;
    });
    if (!target) return;
    var leg = target.querySelector('legend, label');
    if (!leg || leg.querySelector('.vs-size-guide-trigger')) return;
    leg.classList.add('vs-has-size-guide');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vs-size-guide-trigger';
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.innerHTML = SG_ICON + '<span class="vs-size-guide-trigger__label">Size Guide</span>';
    btn.addEventListener('click', function () { var d = buildSizeDialog(); if (d.showModal) d.showModal(); });
    leg.appendChild(btn);
  }
  function sizeGuide(scope) {
    (scope || document).querySelectorAll('variant-picker').forEach(injectSizeGuide);
    // Horizon re-renders the variant picker when a size is selected, which wipes the
    // injected trigger. Observe a stable ancestor and re-inject so it stays visible.
    var host = document.querySelector('.product-information') || document.getElementById('MainContent');
    if (host && !host.dataset.vsSizeObs) {
      host.dataset.vsSizeObs = '1';
      new MutationObserver(function () {
        if (!host.querySelector('.vs-size-guide-trigger')) {
          host.querySelectorAll('variant-picker').forEach(injectSizeGuide);
        }
      }).observe(host, { childList: true, subtree: true });
    }
  }

  /* ---------- PDP: mobile sticky add-to-bag ---------- */
  function stickyAtc() {
    // Only on the product template — never on home/collection (quick-add can expose a product form there)
    var main = document.getElementById('MainContent');
    if (!main || main.getAttribute('data-template') !== 'product') return;
    var form = document.querySelector('product-form-component');
    var realBtn = document.querySelector('button[ref="addToCartButton"]');
    if (!form || !realBtn || document.querySelector('.vs-sticky-atc')) return;
    var titleEl = document.querySelector('.product-information h1');
    var priceEl = document.querySelector('.product-information .price');
    var bar = document.createElement('div');
    bar.className = 'vs-sticky-atc';
    bar.innerHTML =
      '<div class="vs-sticky-atc__info"><span class="vs-sticky-atc__title"></span><span class="vs-sticky-atc__price"></span></div>' +
      '<button type="button" class="button vs-sticky-atc__btn">Add to bag</button>';
    bar.querySelector('.vs-sticky-atc__title').textContent = titleEl ? titleEl.textContent.trim() : '';
    bar.querySelector('.vs-sticky-atc__price').textContent = priceEl ? priceEl.textContent.trim() : '';
    bar.querySelector('.vs-sticky-atc__btn').addEventListener('click', function () {
      if (realBtn.disabled) return;
      realBtn.click();
    });
    document.body.appendChild(bar);
    var anchor = realBtn.closest('.product-form-buttons') || realBtn;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- Craft slideshow: crossfade + progress bar ---------- */
  function craftSlideshow(scope) {
    (scope || document).querySelectorAll('.vs-craft').forEach(function (el) {
      if (el.dataset.vsCraftInit) return;
      el.dataset.vsCraftInit = '1';
      var imgs = el.querySelectorAll('.vs-craft__img');
      var bar = el.querySelector('.vs-craft__progress-bar');
      var interval = (parseFloat(el.getAttribute('data-interval')) || 4) * 1000;
      var i = 0, hasActive = false;
      imgs.forEach(function (im, idx) { if (im.classList.contains('is-active')) { hasActive = true; i = idx; } });
      if (!hasActive && imgs[0]) imgs[0].classList.add('is-active');
      if (imgs.length < 2 || REDUCE) { if (bar) bar.style.display = 'none'; return; }
      function fillBar() {
        if (!bar) return;
        bar.style.transition = 'none';
        bar.style.width = '0%';
        void bar.offsetWidth; // reflow so the next transition restarts
        bar.style.transition = 'width ' + interval + 'ms linear';
        bar.style.width = '100%';
      }
      fillBar();
      setInterval(function () {
        imgs[i].classList.remove('is-active');
        i = (i + 1) % imgs.length;
        imgs[i].classList.add('is-active');
        fillBar();
      }, interval);
    });
  }

  /* ---------- a11y: no focusable element inside [aria-hidden="true"] (WCAG 4.1.2) ---------- */
  var a11yScheduled = false;
  function a11ySync() {
    a11yScheduled = false;
    var foci = document.querySelectorAll('a[href],button,input,select,textarea,iframe,[tabindex],[contenteditable="true"]');
    for (var i = 0; i < foci.length; i++) {
      var el = foci[i];
      if (el.closest('[aria-hidden="true"]')) {
        if (!el.hasAttribute('data-vs-th')) {
          el.setAttribute('data-vs-th', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
          el.setAttribute('tabindex', '-1');
        }
      } else if (el.hasAttribute('data-vs-th')) {
        var prev = el.getAttribute('data-vs-th');
        if (prev === '') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', prev);
        el.removeAttribute('data-vs-th');
      }
    }
    // decorative images without an alt attribute (hero video poster + <video> fallback img)
    var deco = document.querySelectorAll('.hero__video-poster:not([alt]), .hero__video img:not([alt])');
    for (var d = 0; d < deco.length; d++) deco[d].setAttribute('alt', '');
  }
  function a11yObserve() {
    if (window.__vsAhObs) return;
    window.__vsAhObs = new MutationObserver(function () {
      if (a11yScheduled) return;
      a11yScheduled = true;
      requestAnimationFrame(a11ySync);
    });
    window.__vsAhObs.observe(document.documentElement, { attributes: true, attributeFilter: ['aria-hidden'], childList: true, subtree: true });
  }

  /* ---------- Muse List: stable #muse-list target for the announcement bar ----------
     The newsletter section renders as shopify-section-template--<template id>__newsletter,
     and that template id differs per theme, so it can't be linked to directly. */
  function museAnchor(scope) {
    if (document.getElementById('muse-list')) return;
    var section = (scope || document).querySelector('[id$="__newsletter"]');
    if (!section || !section.parentNode) return;
    var a = document.createElement('span');
    a.id = 'muse-list';
    a.setAttribute('aria-hidden', 'true');
    a.style.cssText = 'display:block;scroll-margin-top:var(--header-height,60px)';
    section.parentNode.insertBefore(a, section);
    // arriving from another page, the browser resolved the hash before this ran
    if (window.location.hash !== '#muse-list') return;
    var input = section.querySelector('input[type="email"]');
    // 'instant', not 'auto': <html> carries scroll-behavior:smooth, and 'auto' defers to CSS,
    // so the scroll would animate — and an animated scroll is dropped while the page is still
    // loading. Re-assert a couple of times for late layout shifts, but yield the moment the
    // visitor touches the page themselves.
    var stop = false;
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, function () { stop = true; }, { once: true, passive: true });
    });
    function go() { if (!stop) a.scrollIntoView({ behavior: 'instant', block: 'start' }); }
    go();
    if (document.readyState !== 'complete') window.addEventListener('load', go, { once: true });
    setTimeout(go, 250);
    setTimeout(go, 800);
    if (input) setTimeout(function () { if (!stop) input.focus({ preventScroll: true }); }, 850);
  }

  /* ---------- init / re-init ---------- */
  function init(scope) {
    try { heroEnhance(scope); } catch (e) {}
    try { madeInItalyBadge(scope); } catch (e) {}
    try { sizeGuide(scope); } catch (e) {}
    try { stickyAtc(); } catch (e) {}
    try { craftSlideshow(scope); } catch (e) {}
    try { museAnchor(scope); } catch (e) {}
    try { a11ySync(); a11yObserve(); } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // survive theme-editor section re-renders
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
